import { render, staticRenderFns } from "./LearningGroupForm.vue?vue&type=template&id=2e037210&"
import script from "./LearningGroupForm.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports